import { createFeatureSelector } from '@ngrx/store';

import type { OnboardingStatusState } from './onboarding.reducer';

export const onboardingStatusSelectorKey = 'customerOnboarding';

export const onboardingFeatureSelector =
  createFeatureSelector<OnboardingStatusState>(onboardingStatusSelectorKey);
